import { Box, Button, SaveDialog } from "designSystem/index";
import React, { useState } from "react";

export default () => {
	const [open, setOpen] = useState(false);
	const onClose = () => setOpen(false);
	const onButton = () => setOpen(true);

	async function onSave(): Promise<boolean> {
		// simulate time to save changes
		return new Promise((resolve, reject) => {
			setTimeout(() => resolve(true), 1000);
		});
	}

	return (
		<Box>
			<Button design="primary" onClick={onButton}>
				Save / Cancel Dialog
			</Button>
			<SaveDialog
				onClose={onClose}
				onSave={onSave}
				open={open}
				title="Dialog Title"
			>
				{{
					main: (
						<Box>Custom Content</Box>
					),
				}}
			</SaveDialog>
		</Box>
	);
};